module.exports = __webpack_public_path__ + "d52775c8878da358989c65363300737c.svg";